import { Injectable } from '@angular/core';
import { Http, Jsonp } from '@angular/http';
import 'rxjs/Observable';
import 'rxjs/add/operator/map';
import { VersionService } from '../services/version.service';
import { Config } from '../classes/config';

@Injectable()
export class TargetService {

  constructor(private _http: Http, private _jsonp: Jsonp, private ver: VersionService) { }

  getIndicators(targetId: number) {
    this.ver.activeVersion
    return this._http.get(
      `${Config.apiUrl}/indicator?versionId=${this.ver.activeVersion()}&q=&theme=${targetId.toString()}&callback=JSONP_CALLBACK`
    ).map(resp => resp.json());
  }

  get(targetId: number) {
    return this._http.get(
      `${Config.apiUrl}/beleidsdoel?versionId=${this.ver.activeVersion()}&q=&id=${targetId.toString()}&callback=JSONP_CALLBACK`
    ).map(resp => resp.json());
  }
}



// WEBPACK FOOTER //
// ./src/app/services/target.service.ts